import { getConfig, camelCaseObject } from '@edx/frontend-platform';
import { getAuthenticatedHttpClient } from '@edx/frontend-platform/auth';

export async function fetchOrg(org) {
  const LmsApiUrl = getConfig().LMS_BASE_URL;
  const orgUrl = new URL(`${LmsApiUrl}/api/organizations/v0/organizations/${org}/`);

  let data;
  try {
    ({ data } = await getAuthenticatedHttpClient().get(orgUrl.href));
  } catch (error) {
    data = null;
  }
  return camelCaseObject(data);
}

export async function fetchVerifiedName() {
  const LmsApiUrl = getConfig().LMS_BASE_URL;
  const verifiedNameUrl = new URL(`${LmsApiUrl}/api/edx_name_affirmation/v1/verified_name`);
  let data;
  try {
    ({ data } = await getAuthenticatedHttpClient().get(verifiedNameUrl.href));
  } catch (error) {
    data = null;
  }
  return camelCaseObject(data);
}
